'use client'

import { ToastContainer } from 'react-custom-alert'

export function ToastNotifications() {
  return (
    <div role="status" aria-live="polite" aria-relevant="additions text">
      <ToastContainer
        floatingTime={6000}
        containerStyle={{ zIndex: 20000 }}
        toastStyle={{ overflowWrap: 'anywhere' }}
      />
    </div>
  )
}
